
import {
  Component,
  OnInit,
  forwardRef,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  Injector,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ConfirmationService, DialogService, DynamicDialogRef, FileUpload, MessageService } from 'primeng/primeng';
import { ConfigurationService } from '../../../services/configuration.service';
import { environment } from '../../../../../environments/environment';
import { FileViewerComponent } from '../../file-upload/file-viewer/file-viewer.component';
import { VsFileUploadService } from '../../file-upload/services/file-upload.service';
import { SecondPageEditBase } from '../../../classes/base/second-page-edit-base';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { FileType } from '../../../../dapfood/common/constant';

@Component({
  selector: 'app-vs-file-upload',
  templateUrl: './vs-file-upload.component.html',
  styleUrls: ['./vs-file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VsFileUploadComponent),
      multi: true
    }
  ]
})
export class VsFileUploadComponent extends SecondPageEditBase implements OnInit, ControlValueAccessor {
  disabled = false;
  apiUrl = '';
  uploading = false;
  maxFileSize = 0;
  listUploaded: any[];
  progressValue = 0;
  ref: DynamicDialogRef;
  dragIndex: number = null;
  dragOverIndex: number = null;

  @ViewChild(FileUpload) fileControl: FileUpload;

  @Input() chooseLabel = 'Chọn file';
  @Input() multiple = false;
  @Input() styleButton = false;
  @Input() defaultImage = false;
  @Input() showIconOnly = false;
  @Input() icon = 'fa-light fa-upload';
  @Input() viewOnly = false;
  @Input() fileType = '';    // '' , image/* , video/* , 
  @Input() flexStyle = false;
  @Input() styleBoxWitdhHeight = false;
  @Input() disableDownload = false;
  @Input() idPharmacy = -1;
  @Output() onUploaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFillImage: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(FileViewerComponent) _FileViewerComponent: FileViewerComponent;

  constructor(
    protected _injector: Injector,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _fileUploadService: VsFileUploadService,
    private _configurationService: ConfigurationService,
    public dialogService: DialogService,
  ) {
    super(null, _injector);
    this.apiUrl = `${environment.apiDomain.fileEndpoint}/Files/upload`;  // _moduleConfigService.getConfig().ApiFileUpload;
    this.maxFileSize = this._configurationService.maxFileSize;
  }

  ngOnInit() {
  }

  onChangeControl = (obj: any) => { };
  onTouched = () => { };

  writeValue(obj: any): void {
    this.listUploaded = [];

    if (obj) {
      const fileIds = obj.split(",");
      this.listUploaded = fileIds;
      this._fileUploadService.GetsByIds(obj).then(rs => {
        if (rs.status) {
          this.listUploaded = fileIds
            .map(id => rs.data.find(item => item.id.toString() === id.toString()))
            .filter(item => item);
        }
      }).catch(err => {
        console.log('Có lỗi xảy ra, vui lòng thử lại ' + err);
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeControl = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onUploadEvent(event: any) {
    try {
      const files = event.files;
      if (files.length > 0) {
        if (event.originalEvent.body && event.originalEvent.body.status) {

          // Nếu là single thì clear list đi để lưu ảnh mới, nếu là multi thì push thêm ảnh
          if (this.multiple == false)
            this.listUploaded = [];

          event.originalEvent.body.data.forEach(element => {
            this.listUploaded.push(element);  // list object file    
          });

          this.emitValueChange();

          this.progressValue = 100;
        }
      }
    } catch (e) {
      console.error(e);
    }
    this.uploading = false;
  }
  onProgress(event) {
    // if (event.originalEvent.loaded !== 0) {
    //   this.progressValue = (event.originalEvent.loaded / event.originalEvent.total) * 100;
    // }
  }

  deleteFile(id) {
    this.confirmationService.confirm({
      message: 'Bạn có chắc chắn muốn xóa file này không ?',
      accept: () => {
        const fileToRemove = this.listUploaded.findIndex(x => x.id === id);
        this.listUploaded.splice(fileToRemove, 1);
        let files = this.emitValueChange();

        this.writeValue(files);
      }
    });
  }

  onBeforeSend(ev) {
    console.log(ev);
  }

  onError(ev) {
    console.log(ev);
    this.uploading = false;
  }

  onSelect(ev) {
    console.log(ev);
    // this.messageService.add({ severity: 'error', summary: 'Lỗi upload file', detail: 'Vui lòng kiểm tra lại định dạng file', life: 10000 });
  }

  selectFileUpload() {
    this.fileControl.basicFileInput.nativeElement.click();
  }

  onBeforeUpload() {
    this.progressValue = 1;
    this.uploading = true;
  }

  viewFile(item) {
    // Nếu file là hình ảnh hoặc vido thì dùng FileViewer, Nếu là tài liệu thì dùng VsFileViewer
    if (item.type == FileType.Image || item.type == FileType.Video) {
      this.ref = this.dialogService.open(FileViewerComponent, {
        data: {
          file: item,
          listFile: this.multiple ? this.listUploaded : null,
          idPharmacy: this.idPharmacy
        },
        showHeader: false,
        width: '100%',
        height: 'calc(100vh)',
        styleClass: "vs-modal",
        contentStyle: { 'overflow': 'auto', 'position': 'relative' },
        baseZIndex: 1100,
        closeOnEscape: true,
      });
    }
    else {
      this.ref = this.dialogService.open(DocumentViewerComponent, {
        data: item,
        showHeader: true,
        header: item.fileName,
        width: '100%',
        height: 'calc(100vh - 0px)',
        styleClass: "vs-modal vs-file-viewer",
        contentStyle: { 'overflow': 'auto' }, //'max-height': 'calc(100vh - 180px);', 
        baseZIndex: 1100,
        closeOnEscape: true
      });

    }
  }

  downloadFileAll() {
    this.listUploaded.forEach(element => {
      this.downloadFile(element);
    });
  }

  onReceiveImage(event: any) {
    this.onFillImage.next(event);
  }

  onDragStart(event: DragEvent, index: number) {
    if (!this.canSortFiles()) {
      return;
    }

    this.dragIndex = index;
    this.dragOverIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', index.toString());
    }
  }

  onDragOver(event: DragEvent, index: number) {
    if (!this.canSortFiles() || this.dragIndex === null) {
      return;
    }

    event.preventDefault();
    this.dragOverIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  onDrop(event: DragEvent, dropIndex: number) {
    if (!this.canSortFiles() || this.dragIndex === null) {
      return;
    }

    event.preventDefault();
    if (this.dragIndex !== dropIndex) {
      const movedItems = this.listUploaded.splice(this.dragIndex, 1);
      this.listUploaded.splice(dropIndex, 0, movedItems[0]);
      this.emitValueChange();
    }

    this.clearDragState();
  }

  onDragEnd() {
    this.clearDragState();
  }

  private canSortFiles() {
    return this.multiple === true && this.viewOnly !== true && this.listUploaded && this.listUploaded.length > 1 && this.listUploaded.every(x => this.getFileId(x));
  }

  private emitValueChange() {
    let files = this.listUploaded.map(x => this.getFileId(x)).join(",");
    this.onChangeControl(files);
    this.onUploaded.next(files);
    return files;
  }

  private getFileId(file: any) {
    return file && file.id ? file.id : file;
  }

  private clearDragState() {
    this.dragIndex = null;
    this.dragOverIndex = null;
  }

}
